//
//
//
//
//
//

export default {
  name: 'rb-header-message-bar-item',
  props: {
    url: {
      type: String,
      default: '',
    },
    analyticsDescription: {
      type: String,
      default: '',
    },
  },
}
